"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reportingMessage_1 = require("../reportingMessage");
exports.default = (function () { return (React.createElement(reportingMessage_1.default, { iconName: "icon-table-empty", title: "Looks like Your table is a little empty", message: React.createElement("div", null,
        "Select date range, pick dimensions and metrics along with",
        React.createElement("br", null),
        "filters and constraints, and generate report.") })); });
